import { Empty, Select, Table, Tag } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { serverUrl } from "../../nestserver";
import MomentDatePicker from "../inputs/MomentDatePicker";

const authHeaders = () => ({
  Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
});

/**
 * Students with 100% attendance for a month (admin: whole school, instructor:
 * their classes). Awards are generated on the 1st for the previous month.
 *
 * classesUrl: class list endpoint for the filter (admin `/classes/`,
 * instructor `/teachers/classes` or `/teachers/instructor-classes`).
 */
const StarAttendees = ({ classesUrl = "/classes/" }) => {
  const [month, setMonth] = useState(moment().subtract(1, "month"));
  const [classId, setClassId] = useState();
  const monthStr = month.format("YYYY-MM");

  const classes = useQuery(["star-attendees-classes", classesUrl], async () => {
    const res = await axios.get(serverUrl + classesUrl, {
      headers: authHeaders(),
    });
    return res.data;
  });

  const list = useQuery(
    ["star-attendees", monthStr, classId],
    async () => {
      const res = await axios.get(`${serverUrl}/attendance-appreciation/list`, {
        headers: authHeaders(),
        params: { month: monthStr, ...(classId ? { classId } : {}) },
      });
      return res.data?.result?.data || [];
    },
  );

  const columns = [
    {
      title: "Student",
      render: (r) =>
        `${r.student?.first_name || ""} ${r.student?.last_name || ""}`.trim(),
    },
    { title: "Student ID", render: (r) => r.student?.unique_id || "-" },
    { title: "Class", render: (r) => r.class?.name || "-" },
    {
      title: "School days",
      dataIndex: "total_days",
      render: (v) => <Tag color="green">{v} / {v}</Tag>,
    },
  ];

  return (
    <div className="pt-8">
      <div className="bg-white p-10 rounded-2xl">
        <div className="text-2xl text-orange-500 font-semibold pb-2">
          Star Attendees
        </div>
        <div className="text-gray-500 pb-6">
          Students with 100% attendance in {month.format("MMMM YYYY")}
        </div>

        <div className="flex gap-4 pb-4">
          <MomentDatePicker
            picker="month"
            value={month}
            allowClear={false}
            format="MMMM YYYY"
            disabledDate={(d) => d && d.isAfter(moment().endOf("month"))}
            onChange={(d) => d && setMonth(d)}
          />
          <Select
            allowClear
            showSearch
            placeholder="All classes"
            style={{ width: 220 }}
            optionFilterProp="children"
            onChange={setClassId}
          >
            {(classes.data || []).map((c) => (
              <Select.Option key={c._id} value={c._id}>
                {c.name}
              </Select.Option>
            ))}
          </Select>
        </div>

        <Table
          rowKey="_id"
          columns={columns}
          dataSource={list.data || []}
          loading={list.isLoading}
          pagination={{ pageSize: 10 }}
          locale={{
            emptyText: (
              <Empty description="No student had 100% attendance this month" />
            ),
          }}
        />
      </div>
    </div>
  );
};

export default StarAttendees;
